import { render, staticRenderFns } from "./NewDetailPenawaran.vue?vue&type=template&id=a06e7968&scoped=true"
import script from "./NewDetailPenawaran.vue?vue&type=script&lang=js"
export * from "./NewDetailPenawaran.vue?vue&type=script&lang=js"
import style0 from "./NewDetailPenawaran.vue?vue&type=style&index=0&id=a06e7968&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06e7968",
  null
  
)

export default component.exports